import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './NewsDetailPage.css';

const NewsDetailPage = ({ newsId, onBack }) => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!newsId) {
      setLoading(false);
      return;
    }
    const newsRef = ref(database, `news/${newsId}`);
    const unsubscribe = onValue(newsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setItem({ id: newsId, ...data });
      } else {
        setItem(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [newsId]);

  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (loading) {
    return (
      <div className="news-detail-page">
        <div className="container">
          <p className="news-detail-loading">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!item) {
    return (
      <div className="news-detail-page">
        <div className="container">
          <p className="news-detail-empty">Haber bulunamadı.</p>
          {onBack && (
            <button type="button" onClick={onBack} className="news-detail-back-btn">
              ← Haber listesine dön
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-page">
      <article className="news-detail-article">
        <div className="container">
          {onBack && (
            <button type="button" onClick={onBack} className="news-detail-back-btn">
              ← Haber listesine dön
            </button>
          )}
          <header className="news-detail-header">
            <h1 className="news-detail-title">{item.title}</h1>
            {item.date && (
              <time className="news-detail-date">{formatDate(item.date)}</time>
            )}
          </header>
          <div className="news-detail-body">
            <p className="news-detail-content">{item.content || item.excerpt || ''}</p>
          </div>
        </div>
      </article>
    </div>
  );
};

export default NewsDetailPage;
